import axios from 'axios'

// axios.defaults.withCredentials = false

let baseurl = "http://bigshow.zgaxfp.com/api/"

let accessToken = "QZ1mVal1495gmFlCpr7kErX3wcyixGO37iAn5lZ9YrUrmTfDZWWZbQ87wAH7";

// 创建 axios 实例
let service = axios.create({

    headers: {
        'Content-Type': 'application/json',
        'Accept' : 'application/json',
        'Authorization' : 'Bearer '+accessToken,
    },

    baseURL: baseurl,

    timeout: 60000
})


// 添加请求拦截器
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    // console.log(response);
    return response.data;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});


/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function() {
    return service
}